export { ArchiveaAlt as default } from './ArchiveaAlt';
